import React from 'react';
import SocialConnect from '../components/social/SocialConnect';

const SocialConnectionsPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-slate-900 dark:to-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Page Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                        Social Media Connections
                    </h1>
                    <p className="text-gray-600 dark:text-gray-400">
                        Connect and manage your social media accounts to publish content and track analytics
                    </p>
                </div>

                {/* Social Connect Component */}
                <SocialConnect />

                {/* Help Section */}
                <div className="mt-8 bg-white dark:bg-slate-900/70 rounded-2xl p-6 border border-gray-200/80 dark:border-slate-800 shadow-sm">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
                        Need Help?
                    </h3>
                    <div className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
                        <p>
                            <strong className="text-gray-900 dark:text-gray-100">Why connect social accounts?</strong><br />
                            Connecting your social media accounts allows you to publish content directly from Social Sphere Pro, 
                            schedule posts, and track analytics all in one place.
                        </p>
                        <p>
                            <strong className="text-gray-900 dark:text-gray-100">Is it secure?</strong><br />
                            Yes! We use OAuth 2.0, the industry standard for secure authentication. We never store your passwords 
                            and you can disconnect at any time.
                        </p>
                        <p>
                            <strong className="text-gray-900 dark:text-gray-100">What permissions do you need?</strong><br />
                            We only request the minimum permissions needed to post content and read analytics. You can review 
                            the exact permissions during the connection process.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialConnectionsPage;
